<template>
  <button class="button-toggle" :data-off="!state.isVisibleKeywordSetting" @click.prevent="handleToggle">
    <ToggleSwitch :model-value="state.isVisibleKeywordSetting" @update:model-value="handleToggle" />
    {{ t('keyword_setting') }}
  </button>
</template>

<script setup lang="ts">
import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { DEFAULT_CHAT_UI_STATE } from '@/utils/constants/chat';
import { ij_chat_ui } from '@/utils/injectionKeys';

const { t } = useI18n();

const { actions, state } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE);

const handleToggle = () => {
  actions.toggleKeywordSetting();
};
</script>

<style scoped lang="scss"></style>
